import { useEffect, useState, useRef } from "react";
import { Modal } from "react-bootstrap";
// import BarcodeScanner from "react-qr-barcode-scanner";

const BarcodeScannerModal = ({ show, onHide, onScanSuccess }) => {
  // eslint-disable-next-line 
  const [stopStream, setStopStream] = useState(false);
  // eslint-disable-next-line 
  const [barcodeBuffer, setBarcodeBuffer] = useState("");
  const [manualBarcode, setManualBarcode] = useState("");
  const inputRef = useRef(null);

  // When modal opens → start camera and focus
  useEffect(() => {
    if (show) {
      setStopStream(false);
      setBarcodeBuffer("");
      setManualBarcode("");
      // Focus the input field for manual entry
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    }
  }, [show]);

// eslint-disable-next-line
  const handleUpdate = (err, result) => {
    if (result) {
      onScanSuccess(result.text);
      handleClose();
    }
  };

  const handleClose = () => {
    setStopStream(true);  // stop camera stream
    setBarcodeBuffer("");
    setManualBarcode("");
    setTimeout(() => {
      onHide();
    }, 100);
  };

  const handleManualSubmit = () => {
    const trimmed = manualBarcode.trim();
    if (trimmed.length >= 3) {
      onScanSuccess(trimmed);
      setManualBarcode("");
      handleClose();
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Scan Barcode</Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center">
        {/* Manual Input Section */}
        <div className="mb-3">
          <label className="form-label px-2">Enter Barcode</label>
          <div className="d-flex gap-2 justify-content-center">
            <input
              ref={inputRef}
              type="text"
              className="form-control w-75"
              placeholder="Type or scan barcode"
              value={manualBarcode}
              onChange={(e) => setManualBarcode(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleManualSubmit();
                }
              }}
              style={{ maxWidth: '300px' }}
            />
            <button
              className="btn btn-primary"
              onClick={handleManualSubmit}
              disabled={!manualBarcode.trim()}
            >
              Submit
            </button>
          </div>
        </div>

        {/* Camera Scanner Section */}
        {/* <div className="border-top pt-3">
          <p className="text-muted mb-2">Or scan with camera:</p>
          <BarcodeScanner
            width={400}
            height={400}
            onUpdate={handleUpdate}
            stopStream={stopStream}
          />
          <p className="mt-3">Align the barcode within the frame</p>
          {barcodeBuffer && (
            <p className="text-primary mt-2">Scanning: {barcodeBuffer}...</p>
          )}
        </div> */}
      </Modal.Body>

      <Modal.Footer>
        <button className="btn btn-danger" onClick={handleClose}>
          Cancel
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default BarcodeScannerModal;
